import document from "./ReportDocument.module.css"
import layout from "./ReportLayout.module.css"
import responsive from "./ReportResponsive.module.css"

const sheets: Record<string, string>[] = [layout, document, responsive]

/** Shared document selectors retain their module scope across layout sheets. */
export function reportClass(names: string): string {
  return names
    .split(/\s+/)
    .filter(Boolean)
    .flatMap((name) => {
      const matches = sheets.map((sheet) => sheet[name]).filter(Boolean)
      return matches.length ? matches : [name]
    })
    .join(" ")
}
